import React from 'react'
import styles from './Spinner.module.scss'

type Size = 'sm' | 'md' | 'lg'

interface SpinnerProps {
  size?: Size
  className?: never
}

const sizeMap: Record<Size, string> = { sm: styles.sm, md: styles.md, lg: styles.lg }

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md' }) => (
  <span className={[styles.spinner, sizeMap[size]].join(' ')} />
)
